import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import fetchAPI from './http/fetchAPI';
var downloadTermsOfUse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(setDataUseBlob) {
    var retries,
      _signedUrl,
      _response,
      _blob,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            retries = _args.length > 1 && _args[1] !== undefined ? _args[1] : 3;
            _context.prev = 1;
            _context.next = 4;
            return fetchAPI('/v2/termsOfUse/dataUse/download');
          case 4:
            _signedUrl = _context.sent;
            _context.next = 7;
            return fetch(_signedUrl);
          case 7:
            _response = _context.sent;
            _context.next = 10;
            return _response.blob();
          case 10:
            _blob = _context.sent;
            _blob = _blob.slice(0, _blob.size, 'text/html');
            setDataUseBlob(_blob);
            _context.next = 22;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](1);
            if (!(retries > 0)) {
              _context.next = 22;
              break;
            }
            console.error("Retrying downloadTermsOfUse, attempts remaining: ".concat(retries - 1));
            _context.next = 21;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 2000);
            });
          case 21:
            return _context.abrupt("return", downloadTermsOfUse(setDataUseBlob, retries - 1));
          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 15]]);
  }));
  return function downloadTermsOfUse(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default downloadTermsOfUse;